import {useMemo} from 'react';
import {useIntl} from 'react-intl';

import {capitalize} from 'coreUtils/utils';

import messages from './useProductName/messages';

type TProductInfo = {
	color: string;
	name: string;
};

/**
 * Getting product name and color separated from incoming
 * @param {string} productFullName - product name
 * @returns TProductInfo
 */
export const useProductName = (productFullName: string): TProductInfo => {
	const intl = useIntl();

	const name = useMemo(() => {
		const info = {
			color: '',
			name: ''
		};

		if (productFullName) {
			const productNameSeparated = productFullName.split(', ');

			if (productNameSeparated.length > 1) {
				info.color = intl.formatMessage(messages.color, {color: capitalize(productNameSeparated.pop())});
			}

			info.name = productNameSeparated.join(', ');
		}

		return info;
	}, [productFullName]);

	return name;
};
